import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Leadform from "./Leadform/Leadform";
import Submission from "./Submission/Submission";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Leadform />} />
        <Route path="/form" element={<Leadform />} />
        <Route path="/wordpress-leadform/leadform" element={<Leadform />} />
        <Route path="/submission/:uuid" element={<Submission />} />
        <Route
          path="/wordpress-leadform/leadform/submission/:uuid"
          element={<Submission />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
